import {
  ComponentConfig,
  ComponentType,
  LayoutTypes,
  FlexDirection,
  WidthMode,
} from "../services/types/ComponentTypes";

export const screen_2202_leave_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Apply Leave",
    // Only employees (role 2) should be able to access Apply Leave screen
    visibility: [2],
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "Leave_Add",
        TableName: "employee_leave",
        DisplayName: "Apply Leave",
        columnNumber: "1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        childComponents: [
          {
            name: "date_start",
            label: "From Date",
            placeholder: "Select start date",
            required: true,
            BindValue: "date_start",
            Json_Attribute: "start_date",
            componentType: ComponentType.DATE_FIELD,
            minDate: "today",
          },
          {
            name: "date_end",
            label: "To Date",
            placeholder: "Select end date",
            required: true,
            BindValue: "date_end",
            Json_Attribute: "end_date",
            componentType: ComponentType.DATE_FIELD,
            minDate: "date_start",
          },
          {
            name: "s_select_leave_type",
            label: "Leave Type",
            placeholder: "Select leave type",
            required: true,
            BindValue: "s_select_leave_type",
            Json_Attribute: "leave_type",
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            lookupName: "employee_leave_types_with_balance",
          },
          {
            name: "txt_reason",
            label: "Reason",
            placeholder: "Enter reason for leave",
            required: true,
            BindValue: "txt_reason",
            Json_Attribute: "reason",
            componentType: ComponentType.TEXT_AREA,
            rows: 4,
            maxLength: 500,
          },
          {
            name: "s_select_notify",
            label: "Notify",
            placeholder: "Select person to notify (optional)",
            required: false,
            BindValue: "s_select_notify",
            Json_Attribute: "approved_by",
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            lookupName: "admin_employees",
          },
        ],
      },
      {
        componentType: LayoutTypes.GROUP,
        style: {
          direction: FlexDirection.ROW,
          justifyContent: "space-between",
          padding: 10,
        },
        childComponents: [
          {
            componentType: ComponentType.BUTTON,
            name: "Back",
            onPressAction: "navigate_2201",
            style: {
              widthMode: WidthMode.WRAP,
            },
          },
          {
            componentType: ComponentType.BUTTON,
            name: "Submit",
            onPressAction: "save",
            style: {
              backgroundColor: "var(--primary-green)",
              widthMode: WidthMode.WRAP,
            },
          },
        ],
      },
    ],
  },
];

